var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3054_987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.53188V8.42188C10.5 9.21752 10.1839 9.98059 9.62132 10.5432C9.05871 11.1058 8.29565 11.4219 7.5 11.4219H3.5C2.70435 11.4219 1.94129 11.1058 1.37868 10.5432C0.81607 9.98059 0.5 9.21752 0.5 8.42188V4.42188C0.5 3.62623 0.81607 2.86316 1.37868 2.30055C1.94129 1.73795 2.70435 1.42188 3.5 1.42188H4.56",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05006 0.57L8.61006 2.12L4.13006 6.6C4.09892 6.6307 4.07419 6.66729 4.05731 6.70763C4.04043 6.74797 4.03174 6.79127 4.03174 6.835C4.03174 6.87873 4.04043 6.92203 4.05731 6.96237C4.07419 7.00271 4.09892 7.0393 4.13006 7.07L5.07006 8C5.10076 8.03114 5.13735 8.05587 5.17769 8.07275C5.21803 8.08963 5.26133 8.09832 5.30506 8.09832C5.34879 8.09832 5.39209 8.08963 5.43243 8.07275C5.47277 8.05587 5.50936 8.03114 5.54006 8L10.0001 3.53L11.5501 5.09C11.5808 5.12114 11.6173 5.14587 11.6577 5.16275C11.698 5.17963 11.7413 5.18832 11.7851 5.18832C11.8288 5.18832 11.8721 5.17963 11.9124 5.16275C11.9528 5.14587 11.9894 5.12114 12.0201 5.09C12.0531 5.05962 12.0792 5.02243 12.0964 4.98099C12.1137 4.93955 12.1218 4.89486 12.1201 4.85V0H7.29006C7.20964 0.00981779 7.13565 0.0488745 7.08217 0.10973C7.02869 0.170586 6.99946 0.248987 7.00006 0.33C6.9863 0.413434 7.00413 0.499001 7.05006 0.57Z",
    fill: "#121213"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3054_987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.14,
    height: 11.92,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/LinkIcon.ed75d4535fc58878d59a957e68cb8736.svg";
export { ForwardRef as ReactComponent };